import React, { lazy, Suspense } from "react";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import useChartSelector from "./useChartSelector";

const StyledDivWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 300,
  height: 200,
  marginRight: 20,
  marginTop: 50,
  [theme.breakpoints.down("lg")]: {
    width: 200,
    height: 100,
  },
}));

const StyledDivLoader = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledDivText = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: 10,
});

const StyledTypographyCP = styled(Typography)({
  color: "rgb(77, 174, 79, 1)",
});

const StyledTypographyPP = styled(Typography)({
  color: "rgba(54, 162, 235, 1)",
});

const StyledDivTextWrap = styled("div")({
  display: "flex",
  justifyContent: "space-around",
  flexDirection: "column",
  alignItems: "flex-start",
});

const Doughnut = lazy(() => import("../DefaultExports/Doughnut"));

const backgroundColor = ["rgb(77, 174, 79, .5)", "rgba(54, 162, 235, .5)"];
const borderColor = ["rgb(77, 174, 79, 1)", "rgba(54, 162, 235, 1)"];
const borderWidth = 1;
const hoverOffset = 4;

const Chart = () => {
  const {
    totalAccepted,
    totalAwaiting,
    isFetching,
    isError,
    acceptedWithComma,
    awaitingWithComma,
  } = useChartSelector();

  return (
    <StyledDivWrapper>
      {!isFetching && (totalAccepted || totalAwaiting) ? (
        <>
          <StyledDivTextWrap>
            <StyledDivText>
              <StyledTypographyCP variant="h4">
                ${acceptedWithComma}
              </StyledTypographyCP>
              <StyledTypographyCP style={{ fontSize: 13 }} variant="body2">
                Your Current Revenue
              </StyledTypographyCP>
            </StyledDivText>
            <StyledDivText>
              <StyledTypographyPP variant="h4">
                ${awaitingWithComma}
              </StyledTypographyPP>
              <StyledTypographyPP style={{ fontSize: 13 }} variant="body2">
                Your Potential Revenue
              </StyledTypographyPP>
            </StyledDivText>
          </StyledDivTextWrap>
          <Suspense
            fallback={
              <Typography variant="subtitle1">Creating Chart...</Typography>
            }
          >
            <Doughnut
              data={{
                datasets: [
                  {
                    label: "Projected Revenue",
                    data: [totalAccepted, totalAwaiting],
                    backgroundColor,
                    borderColor,
                    borderWidth,
                    hoverOffset,
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                animation: false,
              }}
            />
          </Suspense>
        </>
      ) : isFetching ? (
        <StyledDivLoader>
          <Typography style={{ paddingRight: 20 }} variant="body1">
            Updating Chart
          </Typography>
          <CircularProgress />
        </StyledDivLoader>
      ) : (
        <Typography>No Revenue Data Found.</Typography>
      )}

      {isError && !isFetching && <Typography>No Quotes Found.</Typography>}
    </StyledDivWrapper>
  );
};

export default Chart;
